import { Target } from './enums';
export const onCustomTarget = (openAllResultUrlsInSameWindow, resultUrlsToOpenInSameWindow, href, linkToFm, retailerCanonical, anchor_target) => {
  if (href === undefined) {
    return '';
  }
  if (openAllResultUrlsInSameWindow || resultUrlsToOpenInSameWindow && resultUrlsToOpenInSameWindow.some(url => href.includes(url))) {
    return Target.self;
  }
  if (linkToFm && retailerCanonical) {
    return Target.blank;
  }
  if (anchor_target === undefined) {
    return Target.self;
  } else {
    return anchor_target;
  }
};